/**
 * Generated runtime TestId mirror for frontend/src/pages/AttributeDefinitions.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AttributeDefinitionsTestIds = {
  attributeDefinitionsPage: "attribute-definitions-page",
  colActions: "col-actions",
  colActive: "col-active",
  colAuthority: "col-authority",
  colDisplayName: "col-display-name",
  colDragHandle: "col-drag-handle",
  colFilterable: "col-filterable",
  colName: "col-name",
  colRequired: "col-required",
  colSearchable: "col-searchable",
  colValueType: "col-value-type",
  createDefinitionButton: "create-definition-button",
  definitionActionDelete: "definition-action-delete",
  definitionActionRemoveFromType: "definition-action-remove-from-type",
  definitionActiveFilter: "definition-active-filter",
  reorderDisabledBanner: "reorder-disabled-banner",
  definitionActionToggleFilterable: (def_name: string) => `definition-action-toggle-filterable-${def_name}`,
  definitionActionToggleFilterablePrefix: () => "definition-action-toggle-filterable-" as TestIdPrefix,
  definitionActionToggleSearchable: (def_name: string) => `definition-action-toggle-searchable-${def_name}`,
  definitionActionToggleSearchablePrefix: () => "definition-action-toggle-searchable-" as TestIdPrefix,
  definitionDragHandle: (def_name: string) => `definition-drag-handle-${def_name}`,
  definitionDragHandlePrefix: () => "definition-drag-handle-" as TestIdPrefix,
  definitionFilterable: (def_name: string) => `definition-filterable-${def_name}`,
  definitionFilterablePrefix: () => "definition-filterable-" as TestIdPrefix,
  definitionRow: (def_name: string) => `definition-row-${def_name}`,
  definitionRowPrefix: () => "definition-row-" as TestIdPrefix,
  definitionRowMenu: (def_name: string) => `definition-row-menu-${def_name}`,
  definitionRowMenuPrefix: () => "definition-row-menu-" as TestIdPrefix,
  definitionSearchable: (def_name: string) => `definition-searchable-${def_name}`,
  definitionSearchablePrefix: () => "definition-searchable-" as TestIdPrefix
} as const;
